import {eyeClosedSvg as Icon__small__eyeClosedSvg} from '../Icon__small/Icon__small--eyeClosed.js'

export var eyeClosed = {
  name: 'eyeClosed',
  category: 'icon',
  colorable: true,
  svg: Icon__small__eyeClosedSvg,
};
